export default {"src":"/_next/static/media/advantages-icon-1.6e047a05.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};